// CategoryPage.jsx
import { useParams } from "react-router-dom";

export default function CategoryPage() {
  const { category } = useParams();
  const label = String(category).replace(/-/g, " ");
  return (
    <>
      <h1 className="text-2xl font-bold capitalize">{label}</h1>
      <p className="mt-2 text-gray-600">Explore topics under {label}</p>
    </>
  );
}